import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import {DayType, DBStatus, Entity, PayPeriodType, Unit, User} from "./common.model";
import {JSonSerializer} from "./JSonSerializer";
import {HourFormatPreference, PrefName, SortOrderPreference, UserPreference} from "./Preferences";

import {TzInfo} from "./TzInfo";
import {EstablishmentProgress} from "../home/establishment/EstablishmentProgress";
import {Utils} from "./Utils";
import {ModuleUser} from "./ModuleUser";
import {ModuleType} from "./ModuleType";
import {HourFormatType} from "../home/schedulePerEmployee/model/SchedulePrintConfig";
import {EmprezMessage} from "./EmprezMessage";
import {UsagerBudget} from "../home/employee/model/UsagerBudget";
import {TwilioUser} from "./TwilioUser";
import {Enterprise} from "./Enterprise";
import {HRConfigAggregation} from "./hr/HRConfigAggregation";

export class UserInfo {
  etag: string;
  fname: string;
  lname: string;
  fullName: string;
  email: string;
  shouldVerifyEmail = false;
  locale: string;
  entity = new Entity();
  user = new User();
  weekStart  = DayType.TUESDAY;
  modules = new Array<ModuleUser>();
  units = new Array<Unit>();
  //divisions = new Array<Unit>(); // Created when deserializing units.
  enterprises = new Array<Enterprise>();
  // prefs = new UserPreferences();
  prefs = new Array<UserPreference>();
  payAnticipation:boolean;
  lastAnticipationDate: Date;

  tzFromPayingEnterprise: string;
  availableTz =  new Array<TzInfo>();
  payingEnterprise = new Enterprise();
  // alias = new Array<NamedWorkShift>();
  establishment = new EstablishmentProgress();
  emprezMessage = new EmprezMessage();
  usagerBudget = new UsagerBudget();
  twilioUsers = new Array<TwilioUser>();

  provinceState = '';
  country = '';
  userCanLeaveTwilioConversation = false;

  userCanSendAudioInTwilioConversation = false;
  userCanSendFileInTwilioConversation = false;
  userCanSendPictureInTwilioConversation = false;

  hrConfigAggregation = new HRConfigAggregation();

  constructor (){

  }

  public get isAbleToChat():boolean{
     if (this.twilioUsers && this.twilioUsers.length>0){
       return true;
     }
     return false;
  }



  public get firstTwilioUser():TwilioUser{
    if (this.isAbleToChat){
      return this.twilioUsers[0];
    }
    return null;
  }


  /**
   * MUST be removed when a proper UserPreferences is implemented.
   */
  /*
  addDefaultUserPreferences(){
    // console.log('Creating UserInfo ');
    if (!this.prefs){
      this.prefs = new UserPreferences();
    }
    let pref = new UserPreference();
    pref.name=PrefName.WORKSHIFT_DEFAULT_START_TIME;
    pref.valueAsString='08:30';
    this.prefs.add(pref);
    pref = new UserPreference();
    pref.name=PrefName.WORKSHIFT_DEFAULT_END_TIME;
    pref.valueAsString='16:30';
    this.prefs.add(pref);
  }
  */
  /**
   * Stupid Shit for Horarius - EmployeeBank Week - EMPLOYE_FTEMPS_SOM
   */
  public startSundayOfWeek( dt: Date): moment.Moment {
    return moment(dt).day(0);
  }

  public startOfWeek( dt: Date): Date {
    return moment(dt).day(this.weekStart.momentCode).toDate();
  }

  public endOfWeek( dt: Date): Date {
    return moment(dt).day(this.weekStart.momentCode + 6).toDate();
  }

  _createFromArray(propertyName: string, data: any) {
    if ('units' === propertyName) {
      // console.log('Working on Array ' + JSON.stringify(data));
      const serializer = new JSonSerializer();
      for (const bean of <Unit[]> data) {
        const tmp = new Unit();
        // console.log('Working on ' + JSON.stringify(bean));
        serializer.deserialize(bean, tmp);
        /*
        if (UnitType.DIVISION === tmp.type){
          this.divisions.push(tmp);
        }else{
          console.log('Not A Division');
        }
        */
        this.units.push(tmp);
      }
    }
    if ('enterprises' === propertyName) {
      // console.log('Working on Array ' + JSON.stringify(data));
      const serializer = new JSonSerializer();
      for (const bean of <Enterprise[]> data) {
        const tmp = new Enterprise();
        // console.log('Working on ' + JSON.stringify(bean));
        serializer.deserialize(bean, tmp);
        this.enterprises.push(tmp);
      }
    }

    if ('prefs' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <UserPreference[]> data) {
        const tmp = new UserPreference();
        serializer.deserialize(bean, tmp);
        if (PrefName.DEFAULT_SORT_ORDER === tmp.prefName){
          const tmp2 = new SortOrderPreference();
          tmp2.copy(tmp);
          this.prefs.push(tmp2);
        } else if (PrefName.HOUR_FORMAT === tmp.prefName){
          const tmp2 = new HourFormatPreference();
          tmp2.copy(tmp);
          this.prefs.push(tmp2);
        }else{
          this.prefs.push(tmp);
        }
      }
    }


    if ('availableTz' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <TzInfo[]> data) {
        const tmp = new TzInfo();
        serializer.deserialize(bean, tmp);
        this.availableTz.push(tmp);
        // this.enterprises.push(tmp);
      }
    }


    if ('modules' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <ModuleUser[]> data) {
        const tmp = new ModuleUser();
        serializer.deserialize(bean, tmp);
        this.modules.push(tmp);
      }
    }

     /*
    if ('alias' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <NamedWorkShift[]> data) {
        const tmp = new NamedWorkShift();
        serializer.deserialize(bean, tmp);
        this.alias.push(tmp);
        // this.enterprises.push(tmp);
      }
    }
    */
    if ('twilioUsers' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <TwilioUser[]> data) {
        const tmp = new TwilioUser();
        serializer.deserialize(bean, tmp);
        this.twilioUsers.push(tmp);
      }
    }

  }


  public get TimeZone(){
    const pref = this.getPref(PrefName.SAVED_TZ);
    if (pref!=null){
      return pref.prefValue;
    }else{
      return momentTz.tz.guess();
    }
  }


  public getPref(name: PrefName): UserPreference{
    for (const pref of this.prefs){
      if (pref.prefName===name){
         return pref;
      }
    }
    return null;
  }

  public getPrefAsHour(name: PrefName,AMPMFormat: boolean = false): Date{
    const pref = this.getPref(name);
    if (!Utils.isNullOrUndefined(pref)){
      return pref.asHour(AMPMFormat);
    }
  }



  public replacePref(pref: UserPreference,addIfNotFound = false): boolean{
    const toReplace = this.getPref(pref.prefName);
    if (!Utils.isNullOrUndefined(toReplace)){
      if (toReplace.prefValue!)
      toReplace.prefValue= pref.prefValue;
      return true;
    }else{
      if (addIfNotFound){
        this.prefs.push(pref);
        return true;
      }
    }
    return false;
  }


  _createSpecialElement(propertyName: string, data: any) {
    if ('weekStart' === propertyName) {
      // weekStart: number; // Careful in Java Sunday is 1, not 0 like in MomentJs.
      this.weekStart = DayType.retrieveFromCode(data);
      return true;
    }
    return false;
  }


  public isAmongRoles (...roles: string[]): boolean {
    if (this.user) {
      for (const r of roles){
        if (this.user.userRole.code === r) {
          return true;
        }
      }
    }
    return false;
  }


  public prepareDayLabels(): string[] {
    return this._prepareDayLabels(7);
  }

  public _prepareDayLabels(nbDays: number): string[] {
    const res = new Array<string>();
    let weekNbr = this.weekStart.momentCode;
    // console.log('momentCode: ' + this.weekStart.momentCode);
    for (let idx = 0 ; idx < nbDays; idx++) {
      const tmp = moment().day(weekNbr).format('dddd');
      // console.log('tmp: ' + tmp);
      const first = tmp.substr(0,1).toUpperCase();
      // console.log('first: ' + first);
      // console.log('pushed: ' + first + tmp.substr(1));
      res.push(first+tmp.substr(1));
      weekNbr++;
    }
    return res;
  }

  public prepareShortDayLabels(): string[] {
    return this._prepareShortDayLabels(7);
  }

  public _prepareShortDayLabels(nbDays: number): string[] {
    const res = new Array<string>();
    let weekNbr = this.weekStart.momentCode;
    // console.log('momentCode: ' + this.weekStart.momentCode);
    for (let idx = 0 ; idx < nbDays; idx++) {
      const tmp = moment().day(weekNbr).format('ddd');
      // console.log('tmp: ' + tmp);
      const first = tmp.substr(0,1).toUpperCase();
      // console.log('first: ' + first);
      // console.log('pushed: ' + first + tmp.substr(1));
      res.push(first+tmp.substr(1));
      weekNbr++;
    }
    return res;
  }

  public isUnitVisible(unitId: string):boolean{
    for (const u of this.units){
      if (u.unitCode === unitId){
        console.log('Unit: ' + unitId  + ' / ' + u.description + ' is visible.');
        return true;
      }
    }
    console.log('Unit: ' + unitId + ' is NOT visible.');
    return false;
  }

  public isAMPM():boolean{
    const up: HourFormatPreference = <HourFormatPreference> this.getPref(PrefName.HOUR_FORMAT);
    if (up){
       const type = up.asCustomCode(HourFormatType.HOUR_24);
       // console.log('Found HourFormatPreference type is: ' + type);
       if (HourFormatType.HOUR_AM_PM === type){
         return true;
       }
       return false;
    }else{
      console.log('Finding it by lang, this.locale: ' + this.locale);
      if ('en-US' === this.locale) {
        return true;
      }
      if ('en-CA' === this.locale) {
        return true;
      }
    }
    return false;
  }

  public getPayPeriodType():PayPeriodType{
    if (!Utils.isNullOrUndefined(this.enterprises)){
      if (this.enterprises.length>0){
        // console.log('Using PayPeriodType of ' + this.enterprises[0].name);
        return this.enterprises[0].payPeriodType;
      }
    }
    return PayPeriodType.TWO_WEEK;

  }

  public getMaxAllowedDateForTimesheets(): Date {
    let maxDate = moment().endOf('day');
    if (this.payAnticipation) {
      if (!Utils.isNullOrUndefined(this.lastAnticipationDate)) {
        maxDate = moment(this.lastAnticipationDate).endOf('day');
      }
    }
    return maxDate.toDate();
  }

  private _retrieveMinimumStartOfPayPeriod(refDate: Date):Date{
    let res = null;
    for (const ent of this.enterprises){
        const period = ent.retrieveFirstDateOfPayOfTheYearFor(refDate);
        if (res){
          if (Utils.isBeforeRefDate(period,res)){
            res = period;
          }
        }else{
          res = period;
        }
    }

    return res;
  }

  public hasAccessToEnterprise(enterpriseId: number):boolean{
    for (const ent of this.enterprises){
      if (enterpriseId === ent.id){
        return true;
      }
    }
    return false;
  }

  public hasAnticipationPay(enterpriseId: number): boolean{
    for (const ent of this.enterprises){
      if (enterpriseId === ent.id){
        console.log('found enterprise: ' + enterpriseId + ' ' + ent.allowPayStub);
        if (DBStatus.ACTIVE === ent.allowPayStub){
          return true;
        }
        break;
      }
    }
    return false;

  }


  /**
   * We want to return the beginning of the previous pay period.
   * If we have several enterprises, then we should take the minimum.
   */
  public getMinAllowedDateForTimesheets(): Date {
    const shouldHaveBeen = moment().subtract(30, 'days').toDate();
    // console.log('Careful before you could modify 30 days from the current date.=> ' + shouldHaveBeen);

    const minOfCurrentPeriod = this._retrieveMinimumStartOfPayPeriod(moment().toDate());
    // console.log('Min CurrentPeriod: ' + moment(minOfCurrentPeriod).format('LLL'));

    const dt = moment(minOfCurrentPeriod).add(-1,'day').startOf('day').toDate();

    const minOfPreviousPeriod = this._retrieveMinimumStartOfPayPeriod(dt);

    // console.log('Min PreviousPeriod: ' + moment(minOfPreviousPeriod).format('LLL'));

    return minOfPreviousPeriod;

    // if (this._currentEnterprise()){
    //   this.startPeriod = moment(this._currentEnterprise().retrieveFirstDateOfPayOfTheYearFor(this.currentDate));
    // }else{


      // return moment().subtract(30, 'days').toDate()
  }


  public get hasProVersion():boolean{

    if (this.modules){
      let res = 0;
      for (const module of this.modules){
        if (ModuleType.SCHEDULE_MODULE === module.moduleType){
            if (module.isActive){
              res +=1;
            }
            continue;
        }
        if (ModuleType.TIMESHEET_MODULE === module.moduleType){
          if (module.isActive){
            res +=1;
          }
          continue;
        }
        if (ModuleType.PAY_MODULE === module.moduleType){
          if (module.isActive){
            res +=1;
          }
          continue;
        }
      }
      if (res === 3){
        return true;
      }
    }
    return false;
  }

  public get hasScheduleModule(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.SCHEDULE_MODULE === module.moduleType){
          if (module.isActive){
            return true;
          }
        }
      }
    }
    return false;
  }

  public get hasPayModule(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.PAY_MODULE === module.moduleType){
          if (module.isActive){
            return true;
          }
        }
      }
    }
    return false;
  }

  public get hasTimesheetModule(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.TIMESHEET_MODULE === module.moduleType){
          if (module.isActive){
            return true;
          }
        }
      }
    }
    return false;
  }


  public get hasExpenseModule(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.EXPENSE_MODULE === module.moduleType){
          if (module.isActive){
            return true;
          }
        }
      }
    }
    return false;
  }


  public get hasHRModule(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.HR_MODULE === module.moduleType){
          if (module.isActive){
            return true;
          }
        }
      }
    }
    return false;
  }




  public get performanceModuleExpirationDate(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.PERFORMANCE_MODULE === module.moduleType){
          return module.expiryDate;
        }
      }
    }
    return null;
  }


  public get performanceModuleExpirationDaysLeft(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.PERFORMANCE_MODULE === module.moduleType){
          return Utils.diffDateInDays(moment().toDate(),module.expiryDate);
        }
      }
    }
    return null;
  }



  public get hasPerformanceModule(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.PERFORMANCE_MODULE === module.moduleType){
          if (module.isActive){
            return true;
          }
        }
      }
    }
    return false;
  }

  public get hasNoPerformanceInItsModules(){
    if (this.modules){
      for (const module of this.modules){
        if (ModuleType.PERFORMANCE_MODULE === module.moduleType){
          return false;
        }
      }
    }
    return true;
  }


}
